import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons'

import CheckBox from 'src/components/CheckBox'
import Tooltip  from 'src/components/Tooltip'

const CoverCosts = ({ i18n, donation, tipping }) =>
  tipping.type == 'cover_costs' &&
  <CheckBox
    id="cover-costs"
    checked={donation.state.coverCosts}
    onChange={e =>
      donation.dispatch({ type: 'setCoverCosts', value: e.target.checked })
    }
    label={i18n.t('cover_costs', {
      fees: i18n.formatCurrency(donation.fees, donation.currency)
    })}
    afterLabel={
      <Tooltip title={i18n.t('cover_costs_tooltip')}>
        <FontAwesomeIcon icon={faQuestionCircle} />
      </Tooltip>
    }
  />

export default CoverCosts
